// src/components/DocumentListButton.tsx
import React from "react";
import { FileText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { EnhancedDocumentLink } from "@/types";

interface DocumentListButtonProps {
  processData: any[];
  onShowDocumentList: (documents: EnhancedDocumentLink[]) => void;
  iconsOnly?: boolean;
}

const DocumentListButton: React.FC<DocumentListButtonProps> = ({
  processData,
  onShowDocumentList,
  iconsOnly = false
}) => {
  // Samla alla dokument från processData
  const handleShowDocuments = () => {
    // Collect all documents from processData
    const allDocuments = processData
      .flatMap(item => {
        if (!item.field_4) return [];
        
        const parsedDocs = item.field_4.split(";")
          .map((docStr: string) => {
            const match = docStr.match(/(.*?)\s*\((.*?)\)/);
            if (match && match[1] && match[2]) {
              return {
                title: match[1].trim(),
                url: match[2].trim(),
                process: item.Title,
                subProcess: item.field_0,
                moment: item.field_2,
                hierarchicalNumber: item.hierarchicalNumber
              };
            }
            return null;
          })
          .filter((doc: any): doc is EnhancedDocumentLink => doc !== null); // Type guard för att filtrera bort null
        
        return parsedDocs;
      });
    
    // Sort by hierarchicalNumber if available
    const sortedDocs = allDocuments.sort((a, b) => {
      if (a.hierarchicalNumber && b.hierarchicalNumber) {
        return a.hierarchicalNumber.localeCompare(b.hierarchicalNumber);
      }
      return a.title.localeCompare(b.title);
    });
    
    // Viktigt: Logga antalet dokument för debugging
    console.log(`Found ${sortedDocs.length} documents to display`);
    
    // Skicka vidare dokumenten till callback-funktionen
    onShowDocumentList(sortedDocs);
  };

  // Gemensam style för header-knappar med bara ikoner
  const headerButtonStyle = "bg-gray-800/50 text-gray-300 border border-gray-700 hover:bg-orange-300/10 hover:text-orange-300 transition-colors flex items-center justify-center h-9 w-9 p-0";

  if (iconsOnly) {
    return (
      <Button
        variant="outline"
        size="icon"
        className={headerButtonStyle}
        onClick={handleShowDocuments}
        aria-label="Dokumentlista"
      >
        <FileText className="h-4 w-4" />
      </Button>
    );
  }

  return (
    <Button
      variant="outline"
      size="sm"
      className="bg-gray-800/50 text-gray-300 border border-gray-700 hover:bg-orange-300/10 hover:text-orange-300 transition-colors"
      onClick={handleShowDocuments}
    >
      <FileText className="h-4 w-4 mr-2" />
      Dokumentlista
    </Button>
  );
};

export default DocumentListButton;